<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI CHÍNH SÁCH</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT CHÍNH SÁCH</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT CHÍNH SÁCH</h3>
      </div>

      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-position="top"
        >
          <b-row>
            <b-col :md="mData.viewMode !== 'create' ? '3' : '4'">
              <el-form-item label="Tiêu đề" prop="tieu_de">
                <el-input
                  v-model="mData.dataForm.tieu_de"
                  :disabled="mData.viewMode == 'detail'"
                  @change="fn_changeTieuDe"
                  clearable
                  @input="forceUpdateUI"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col :md="mData.viewMode !== 'create' ? '3' : '4'">
              <el-form-item label="Mô tả">
                <el-input
                  placeholder="Nhập mô tả ngắn gọn"
                  v-model="mData.dataForm.mo_ta"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                >
                </el-input>
              </el-form-item>
            </b-col>

            <b-col :md="mData.viewMode !== 'create' ? '3' : '4'">
              <el-form-item
                label="Phân loại"
                prop="phan_loai"
                id="phan-loai-chinh-sach"
              >
                <el-select
                  v-model="mData.dataForm.phan_loai"
                  placeholder="Phân loại chính sách"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                >
                  <el-option
                    v-for="item in mData.phanLoai"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col :md="mData.viewMode !== 'create' ? '3' : '4'">
              <div class="thu-tu" v-show="mData.viewMode !== 'create'">
                <el-form-item label="Thứ tự" prop="thu_tu">
                  <el-select
                    v-model="mData.dataForm.thu_tu"
                    :disabled="mData.viewMode == 'detail'"
                  >
                    <el-option
                      v-for="item in arrThuTu"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </b-col>
          </b-row>
          <div class="group-chinh-sach">
            <div class="hien-thi">
              <el-form-item prop="hien_thi"
                ><el-checkbox
                  @change="fn_hienThiChinhSach"
                  :disabled="mData.viewMode == 'detail'"
                  v-model="mData.dataForm.hien_thi"
                  >Hiển thị chính sách</el-checkbox
                ></el-form-item
              >
            </div>
          </div>
          <br />
          <div class="label-s">
            <el-form-item label="Nội dung">
              <NoiDung
                :propDataEditor="mData.dataForm.noi_dung"
                @newData="fn_newData"
                :height="'580px'"
              ></NoiDung>
            </el-form-item>
          </div>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_add()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormChinhSach";
import { Circle4 } from "vue-loading-spinner";
import NoiDung from "../../../component/EditorComponent.vue";
import LanguageService from "../../../service/LanguageService";
import ValidService from "../../../service/ValidService";
export default {
  components: {
    Circle4,
    NoiDung,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        tableRules: MethodService.copyObject(DataForm.tableRules),
        phanLoai: MethodService.copyObject(DataForm.phanLoai),
        validForm: MethodService.copyObject(DataForm.validForm),
      },
      // validForm: {
      //   tieu_de: [ValidService.required, ValidService.checkSpaceString],
      //   phan_loai: [ValidService.required],
      // },
      newData: "",

      numIOS: 0, // số chính sách ios để cập nhật/thêm mới trường thứ tự
      numINAPP: 0, // số chính sách inapp để cập nhật/thêm mới trường thứ tự
      numWEB: 0, // số chính sách web để cập nhật/thêm mới trường thứ tự
      numIPHONE: 0, // số chính sách iphone để cập nhật/thêm mới trường thứ tự
      numIPAD: 0, // số chính sách ipad để cập nhật/thêm mới trường thứ tự
      numANDROID: 0, // số chính sách android để cập nhật/thêm mới trường thứ tự
      thu_tu_current: 0,
      arrThuTu: [],
    };
  },
  methods: {
    async fn_getPhanLoaiChinhSach() {
      try {
        const response = await mushroom.chinh_sach.listAsync({
          fields:
            "id,thu_tu,hien_thi,phan_loai,tieu_de,noi_dung,thoi_diem_tao,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
          limit: 1000,
        });
        response.result.forEach((item) => {
          if (item.phan_loai == "ios") {
            this.numIOS += 1;
          }
          if (item.phan_loai == "inapp") {
            this.numINAPP += 1;
          }
          if (item.phan_loai == "web") {
            this.numWEB += 1;
          }
          if (item.phan_loai == "iphone") {
            this.numIPHONE += 1;
          }
          if (item.phan_loai == "ipad") {
            this.numIPAD += 1;
          }
          if (item.phan_loai == "android") {
            this.numANDROID += 1;
          }
        });
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initForm() {
      try {
        const response = await mushroom.chinh_sach.listAsync({
          fields:
            "id,thu_tu,hien_thi,phan_loai,tieu_de,mo_ta,noi_dung,thoi_diem_tao,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
          filters: ["id=" + this.$router.currentRoute.params.id],
          limit: 1000,
        });
        this.mData.dataForm = response.result[0];
        console.log("Chính sách:", this.mData.dataForm);
        this.thu_tu_current = response.result[0].thu_tu;
        this.mData.dataForm.tieu_de = this.mData.dataForm.tieu_de.trim();

        // lấy thứ tự theo phan_loai
        const responseThuTu = await mushroom.chinh_sach.listAsync({
          filters: ["phan_loai=" + response.result[0].phan_loai],
          limit: 1000,
        });
        if (responseThuTu) {
          responseThuTu.result.forEach((item) => {
            this.arrThuTu.push({
              value: item.thu_tu,
              label: item.thu_tu,
            });
          });
          console.log("ds thu tu", this.arrThuTu);
        }
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    fn_hienThiChinhSach(event) {
      this.mData.dataForm.hien_thi = event;
    },

    //thay đổi tiêu đề
    fn_changeTieuDe() {
      this.mData.dataForm.tieu_de = this.mData.dataForm.tieu_de.trim();
    },
    // thêm mới chính sách
    async fn_add() {
      const chinh_sach_object = {
        hien_thi: this.mData.dataForm.hien_thi,
        phan_loai: this.mData.dataForm.phan_loai,
        tieu_de: this.mData.dataForm.tieu_de,
        noi_dung: this.newData,
        mo_ta: this.mData.dataForm.mo_ta,
      };
      if (chinh_sach_object.phan_loai == "ios") {
        chinh_sach_object.thu_tu = this.numIOS + 1;
      }
      if (chinh_sach_object.phan_loai == "inapp") {
        chinh_sach_object.thu_tu = this.numINAPP + 1;
      }
      if (chinh_sach_object.phan_loai == "web") {
        chinh_sach_object.thu_tu = this.numWEB + 1;
      }
      if (chinh_sach_object.phan_loai == "iphone") {
        chinh_sach_object.thu_tu = this.numIPHONE + 1;
      }
      if (chinh_sach_object.phan_loai == "ipad") {
        chinh_sach_object.thu_tu = this.numINAPP + 1;
      }
      if (chinh_sach_object.phan_loai == "android") {
        chinh_sach_object.thu_tu = this.numANDROID + 1;
      }

      console.log("chinh_sach_object", chinh_sach_object);
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (this.newData.trim() == "") {
            window.toastr.error("Phải nhập nội dung chính sách");
            MethodService.stopLadda();
          } else if (this.mData.dataForm.tieu_de.trim() == "") {
            window.toastr.error("Phải tiêu đề dung chính sách");
            MethodService.stopLadda();
          } else {
            try {
              await mushroom.chinh_sach.createAsync(chinh_sach_object);
              MethodService.stopLadda();
              this.fn_resetForm();
              window.toastr.success("Thêm mới Chính sách mới thành công");
              this.$router.go(-1);
            } catch (error) {
              console.error("Có lỗi: %o", error);
              MethodService.stopLadda();
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Gặp sự cố tải dữ liệu");
              } else {
                window.toastr.error("Đã có lỗi xảy ra");
              }
            }
          }
        } else MethodService.stopLadda();
      });
    },

    // fn_changeChinhSach(e) {
    //   if (e) {
    //     $("#phan-loai-chinh-sach").removeClass("is-error");
    //     $("#phan-loai-chinh-sach .el-form-item__error").text("");
    //   }
    // },

    // cập nhật chính sách
    async fn_update() {
      const update_chinh_sach_object = {
        id: this.$router.currentRoute.params.id,
        hien_thi: this.mData.dataForm.hien_thi,
        phan_loai: this.mData.dataForm.phan_loai,
        tieu_de: this.mData.dataForm.tieu_de,
        noi_dung: this.newData,
        mo_ta: this.mData.dataForm.mo_ta,
        thu_tu: this.mData.dataForm.thu_tu,
      };
      if (this.mData.dataForm.tieu_de.trim() == "") {
        MethodService.stopLadda();
      } else if (this.mData.dataForm.thu_tu == null) {
        MethodService.stopLadda();
        window.toastr.warning("Thứ tự không được để trống");
      } else {
        try {
          // cập nhật thứ tự của chính sách bị lấy mất thứ tự

          const responseOld = await mushroom.chinh_sach.listAsync({
            filters: [
              "thu_tu=" + this.mData.dataForm.thu_tu,
              "phan_loai=" + this.mData.dataForm.phan_loai,
            ],
          });
          console.log("responseOld", responseOld.result);
          if (responseOld.result.length !== 0) {
            const chinh_sach_object_old = {
              id: responseOld.result[0].id,
              thu_tu: this.thu_tu_current,
            };
            await mushroom.chinh_sach.partialUpdateAsync(chinh_sach_object_old);
          }

          const response = await mushroom.chinh_sach.partialUpdateAsync(
            update_chinh_sach_object
          );
          if (response.result == this.$router.currentRoute.params.id) {
            window.toastr.success("Cập nhật Chính sách thành công");
            MethodService.stopLadda();
            this.$router.go(-1);
          } else window.toastr.warning("Dữ liệu Chính sách không thay đổi");
        } catch (error) {
          console.error("Có lỗi: %o", error, error.message);
          MethodService.stopLadda();
          if (error.code === 4) {
            window.toastr.error(this.aLang.no_server);
          } else if (error.code === 2) {
            window.toastr.error("Gặp sự cố tải dữ liệu");
          } else window.toastr.error("Đã có lỗi xảy ra");
        }
      }
    },

    // quay lại danh sách Cấu Hình
    fn_back() {
      this.$router.go(-1);
    },

    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },

    fn_cancel() {
      this.fn_resetForm();
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_newData(data) {
      this.newData = data;
    },
  },

  async created() {
    await this.fn_getPhanLoaiChinhSach();
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "ThemMoiChinhSach") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietChinhSach") {
      this.mData.viewMode = "detail";
      await this.fn_initForm();
    }
    if (this.$router.currentRoute.name == "CapNhatChinhSach") {
      this.mData.viewMode = "update";
      await this.fn_initForm();
    }
  },
};
</script>

<style lang="scss" scoped>
.thu-tu {
  display: flex;
}
::v-deep .toastui-editor-toolbar-group button.image {
  display: none !important;
}
::v-deep .label-s label::after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
  font-weight: bold;
}
@media (min-width: 768px) {
  .group-chinh-sach {
    display: flex;
  }
  .thu-tu {
    margin-left: 30px;
  }
}
</style>
